(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safegaard-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const openedItem = event.target;
    if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.open) return;
    const list = openedItem.closest('[data-sg-faq-single]');
    if (!list) return;
    list.querySelectorAll('details[open]').forEach((item) => {
      if (item !== openedItem) item.open = false;
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safegaard-feature-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('safegaard-feature-grid')) {
    customElements.define('safegaard-feature-grid', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.revealObserver?.disconnect();
        this.iconObserver?.disconnect();
        this.stickyObserver?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dataset.sgfInViewport = 'false';
        if (this.dataset.hideStickyAtc === 'true') {
          const syncStickyVisibility = () => {
            const rect = this.getBoundingClientRect();
            this.dataset.sgfInViewport = String(this.isConnected && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth);
          };
          syncStickyVisibility();
          if ('IntersectionObserver' in window) {
            const stickyObserver = new IntersectionObserver(entries => {
              if (!this.isConnected || this.stickyObserver !== stickyObserver) return;
              const entry = entries.find(item => item.target === this);
              if (entry) this.dataset.sgfInViewport = String(entry.isIntersecting);
            }, { threshold: 0 });
            this.stickyObserver = stickyObserver;
            this.stickyObserver.observe(this);
          } else {
            window.addEventListener('scroll', syncStickyVisibility, { passive: true, signal });
            window.addEventListener('resize', syncStickyVisibility, { passive: true, signal });
          }
        }
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const tilesEnabled = this.dataset.tileAnimation === 'true';
        const iconsEnabled = this.dataset.iconAnimation === 'true';
        const hoverIconsEnabled = this.dataset.iconHover === 'true';
        const repeatTiles = this.dataset.tileRepeat === 'true';
        const baseDelay = Math.max(0, Number(this.dataset.tileDelay) || 0);
        const stagger = Math.max(0, Number(this.dataset.tileStagger) || 0);
        this.records = [...this.querySelectorAll('[data-sgf-card]')].map((card, index) => ({
          card, index, icon: card.querySelector('.sgf__icon'),
          seen: card.dataset.sgfRevealed === 'true',
          iconSeen: !!card.querySelector('.sgf-icon-entered'), iconInView: false, tileStart: 0
        }));
        const recordsByCard = new Map(this.records.map(record => [record.card, record]));
        const recordsByIcon = new Map(this.records.filter(record => record.icon).map(record => [record.icon, record]));
        const playIcon = (record, delay = 0) => {
          if (!this.isConnected || motion.matches || !record.icon || record.icon.dataset.iconEffect === 'none') return;
          record.icon.classList.remove('sgf-icon-entered');
          record.icon.style.setProperty('--sgf-icon-enter-delay', `${delay}ms`);
          void record.icon.offsetWidth;
          record.icon.classList.add('sgf-icon-entered');
        };
        const animateIcon = record => {
          if (!iconsEnabled || motion.matches || !record.icon || record.iconSeen || !record.iconInView || record.icon.dataset.iconEffect === 'none') return;
          if (tilesEnabled && !record.card.classList.contains('sgf-is-visible')) return;
          const remainingDelay = Math.max(0, record.tileStart - performance.now());
          playIcon(record, remainingDelay);
          record.iconSeen = true;
          if (!repeatTiles) this.iconObserver?.unobserve(record.icon);
        };
        const resetIcon = record => {
          if (!repeatTiles || !record.icon) return;
          record.icon.classList.remove('sgf-icon-entered');
          record.iconSeen = false;
          record.icon.style.setProperty('--sgf-icon-enter-delay', '0ms');
        };
        if (hoverIconsEnabled) {
          this.records.forEach(record => record.card.addEventListener('pointerenter', event => {
            if (event.pointerType === 'touch' || !window.matchMedia('(any-hover: hover)').matches) return;
            if (this.classList.contains('sgf--reveal-ready') && !record.card.classList.contains('sgf-is-visible')) return;
            playIcon(record, Math.max(0, record.tileStart - performance.now()));
          }, { signal }));
        }
        this.reveal = (record, delay = 0) => {
          record.card.style.setProperty('--sgf-tile-enter-delay', `${delay}ms`);
          record.card.classList.add('sgf-is-visible');
          record.card.dataset.sgfRevealed = 'true';
          record.seen = true;
          record.tileStart = performance.now() + delay;
          animateIcon(record);
          if (!repeatTiles || !tilesEnabled) this.revealObserver?.unobserve(record.card);
        };
        const setupReveal = () => {
          this.revealObserver?.disconnect();
          this.iconObserver?.disconnect();
          this.revealObserver = null;
          this.iconObserver = null;
          this.classList.remove('sgf--reveal-ready');
          if (motion.matches || !('IntersectionObserver' in window) || (!tilesEnabled && !iconsEnabled)) {
            this.records.forEach(record => record.card.classList.add('sgf-is-visible'));
            return;
          }
          try {
            const inset = Math.min(Math.max(0, Number(this.dataset.triggerInset) || 0), Math.floor(window.innerHeight * .4));
            const observer = new IntersectionObserver(entries => {
              if (!this.isConnected || this.revealObserver !== observer) return;
              const entering = entries.filter(entry => entry.isIntersecting && entry.intersectionRatio > 0)
                .map(entry => recordsByCard.get(entry.target)).filter(Boolean)
                .sort((a, b) => a.index - b.index);
              entering.forEach((record, index) => this.reveal(record, tilesEnabled ? baseDelay + index * stagger : 0));
              if (tilesEnabled && repeatTiles) {
                entries.filter(entry => !entry.isIntersecting).forEach(entry => {
                  const record = recordsByCard.get(entry.target);
                  if (!record) return;
                  record.card.style.setProperty('--sgf-tile-enter-delay', '0ms');
                  record.card.classList.remove('sgf-is-visible');
                  resetIcon(record);
                });
              }
            }, { threshold: 0.01, rootMargin: `0px 0px -${inset}px 0px` });
            this.revealObserver = observer;
            if (iconsEnabled) {
              const iconObserver = new IntersectionObserver(entries => {
                if (!this.isConnected || this.iconObserver !== iconObserver) return;
                entries.forEach(entry => {
                  const record = recordsByIcon.get(entry.target);
                  if (!record) return;
                  record.iconInView = entry.isIntersecting && entry.intersectionRatio >= .2;
                  if (!record.iconInView) resetIcon(record);
                  animateIcon(record);
                });
              }, { threshold: .2 });
              this.iconObserver = iconObserver;
            }
            this.records.forEach(record => {
              if (tilesEnabled && (repeatTiles || !record.seen)) record.card.classList.remove('sgf-is-visible');
              else record.card.classList.add('sgf-is-visible');
              const iconNeedsEntry = iconsEnabled && record.icon && (repeatTiles || !record.iconSeen) && record.icon.dataset.iconEffect !== 'none';
              if (tilesEnabled && (repeatTiles || !record.seen)) observer.observe(record.card);
              if (iconNeedsEntry) this.iconObserver.observe(record.icon);
            });
            if (tilesEnabled) this.classList.add('sgf--reveal-ready');
          } catch {
            this.revealObserver?.disconnect();
            this.iconObserver?.disconnect();
            this.classList.remove('sgf--reveal-ready');
            this.records.forEach(record => record.card.classList.add('sgf-is-visible'));
          }
        };
        setupReveal();
        motion.addEventListener('change', setupReveal, { signal });
        document.addEventListener('shopify:block:select', event => {
          const selectedCard = event.target.closest?.('[data-sgf-card]');
          const record = recordsByCard.get(selectedCard) || this.records.find(item => event.detail?.blockId && item.card.id.endsWith(`-${event.detail.blockId}`));
          if (record) this.reveal(record);
        }, { signal });
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains?.(this)) this.records.forEach(record => this.reveal(record));
        }, { signal });
        this.addEventListener('focusin', event => {
          const record = recordsByCard.get(event.target.closest?.('[data-sgf-card]'));
          if (record) this.reveal(record);
        }, { signal });
        this.videos = [...this.querySelectorAll('.sgf__media video')];
        const startVideo = video => {
          if (!this.isConnected || document.hidden || !video.paused) return;
          video.muted = true;
          const playing = video.play();
          if (playing?.catch) playing.catch(() => {});
        };
        this.videos.forEach(video => {
          video.autoplay = true;
          video.loop = true;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.controls = false;
          video.addEventListener('canplay', () => startVideo(video), { signal });
          startVideo(video);
        });
        document.addEventListener('visibilitychange', () => this.videos.forEach(startVideo), { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.revealObserver?.disconnect();
        this.iconObserver?.disconnect();
        this.stickyObserver?.disconnect();
        this.dataset.sgfInViewport = 'false';
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safegaard-judge-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sg-judge-reviews')) {
    class SgJudgeReviews extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.renderFrame);
        this.mutations?.disconnect();
        this.resize?.disconnect();
        this.reveals?.disconnect();
        this.events?.abort();
        clearInterval(this.timer);
      }

      initialize() {
        this.sourceHost = this.querySelector('[data-source]');
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        if (!this.sourceHost || !this.track || !this.controls) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelector('[data-previous]').addEventListener('click', () => this.advance(-1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.advance(1), options);
        this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || this.dataset.layout !== 'carousel') return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.advance(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
        this.addEventListener('focusin', () => { this.focused = true; }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); }, options);
        if (this.dataset.navigation === 'bottom') this.querySelector('[data-bottom-navigation]').append(this.controls);
        this.mutations = new MutationObserver(() => this.scheduleRender());
        this.mutations.observe(this.sourceHost, { childList: true, subtree: true, characterData: true });
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.updateControls());
          this.resize.observe(this.track);
        }
        const seconds = Number(this.dataset.autoplay);
        if (seconds > 0 && this.dataset.layout === 'carousel' && !this.reducedMotion()) {
          this.timer = setInterval(() => {
            if (!document.hidden && !this.hovered && !this.focused && !window.jdgmCarouselLightbox?.container?.querySelector('[role="dialog"]')) this.advance(1, true);
          }, seconds * 1000);
        }
        this.renderSummary();
        this.scheduleRender();
      }

      reducedMotion() {
        return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
      }

      enabled(name) {
        return this.dataset[name] === 'true';
      }

      scheduleRender() {
        cancelAnimationFrame(this.renderFrame);
        this.renderFrame = requestAnimationFrame(() => this.renderReviews());
      }

      safeUrl(value) {
        try {
          const url = new URL(value, window.location.href);
          return value && ['http:', 'https:'].includes(url.protocol) ? url.href : '';
        } catch { return ''; }
      }

      node(tag, className, text) {
        const node = document.createElement(tag);
        node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      }

      svg(path, viewBox = '0 0 24 24') {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', viewBox);
        svg.setAttribute('aria-hidden', 'true');
        const shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        shape.setAttribute('d', path);
        shape.setAttribute('fill', 'currentColor');
        svg.append(shape);
        return svg;
      }

      stars(rating) {
        const value = Math.max(0, Math.min(5, Number(rating) || 0));
        const stars = this.node('span', 'sg-rv__stars');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${value} ${this.dataset.ratingLabel}`);
        stars.style.setProperty('--sg-rv-fill', `${value * 20}%`);
        const starPath = 'm12 2.2 2.95 5.97 6.59.96-4.77 4.65 1.13 6.57L12 17.25l-5.9 3.1 1.13-6.57L2.46 9.13l6.59-.96Z';
        for (const className of ['sg-rv__stars-base', 'sg-rv__stars-fill']) {
          const layer = this.node('span', className);
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 128 24');
          svg.setAttribute('aria-hidden', 'true');
          for (let index = 0; index < 5; index++) {
            const shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            shape.setAttribute('d', starPath);
            shape.setAttribute('transform', `translate(${index * 26}, 0)`);
            shape.setAttribute('fill', 'currentColor');
            svg.append(shape);
          }
          layer.append(svg);
          stars.append(layer);
        }
        return stars;
      }

      renderSummary(source) {
        const summary = this.querySelector('[data-summary]');
        if (!summary) return;
        const ratingNode = source?.querySelector('.jdgm-rating-text');
        const firstText = ratingNode ? [...ratingNode.childNodes].find(node => node.nodeType === Node.TEXT_NODE)?.textContent : '';
        const nativeRating = Number.parseFloat(firstText?.replace(',', '.'));
        const nativeCount = source?.querySelector('.jdgm-reviews-count')?.textContent?.replace(/\D/g, '');
        const rating = Number.isFinite(nativeRating) ? nativeRating : Number(this.dataset.rating);
        const count = nativeCount ? Number(nativeCount) : Number(this.dataset.count);
        summary.hidden = !(count > 0);
        if (!(count > 0)) return;
        const details = this.node('span', 'sg-rv__summary-text');
        const score = this.node('strong', '', `${new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(rating)} / 5`);
        details.append(score, document.createTextNode(` · ${new Intl.NumberFormat(document.documentElement.lang || 'en').format(count)} ${this.dataset.reviewsLabel}`));
        summary.replaceChildren(this.stars(rating), details);
      }

      readReview(card, index, recordsById) {
        const matched = recordsById.get(card.dataset.reviewId);
        const record = matched?.record;
        const textNode = card.querySelector('.jdgm-text');
        const paragraphs = textNode ? [...textNode.querySelectorAll('p')] : [];
        const body = paragraphs.length ? paragraphs.map(p => p.textContent.trim()).filter(Boolean).join('\n\n') : textNode?.textContent.trim() || '';
        const product = card.querySelector('.jdgm-product-name');
        const productLink = product?.querySelector('a');
        const image = card.querySelector('img');
        const onStars = card.querySelectorAll('.jdgm-rating-section .jdgm-star.jdgm--on').length;
        const halfStars = card.querySelectorAll('.jdgm-rating-section .jdgm-star.jdgm--half').length;
        return {
          id: card.dataset.reviewId || String(index),
          sourceCard: card,
          sourceRecord: record,
          sourcePosition: matched?.position ?? index,
          title: record?.translation?.title || record?.title || '',
          body,
          name: card.querySelector('.jdgm-reviewer-name')?.textContent.trim() || '',
          rating: Number.isFinite(Number(record?.rating)) ? Number(record.rating) : onStars + halfStars * 0.5,
          product: product?.textContent.trim() || '',
          productUrl: this.safeUrl(productLink?.getAttribute('href')),
          image: this.safeUrl(image?.getAttribute('src')),
          srcset: image?.getAttribute('srcset') || '',
          video: card.classList.contains('jdgm-video-card')
        };
      }

      openReview(review) {
        const source = this.sourceHost.querySelector('.jdgm-cards-carousel');
        const records = window.jdgmCarouselMode?.[source?.dataset.jdgmBlockId]?.reviews;
        const record = records?.find(item => String(item.uuid) === review.id) || review.sourceRecord;
        if (record && typeof window.jdgmCarouselLightbox?.open === 'function' && typeof window.jdgmCarouselUtils?.openCarouselLightbox === 'function') {
          window.jdgmCarouselUtils.openCarouselLightbox(record, source);
          return;
        }
        const sourceCard = [...(source?.querySelectorAll('.jdgm-media-card') || [])].find(card => card.dataset.reviewId === review.id) || review.sourceCard;
        const position = records?.findIndex(item => String(item.uuid) === review.id) ?? -1;
        if (position >= 0) sourceCard.dataset.cardIndex = String(position);
        if (!records?.length || position >= 0) sourceCard.click();
      }

      buildReview(review, index) {
        const card = this.node('article', 'sg-rv__card');
        card.dataset.reviewId = review.id;
        card.style.setProperty('--sg-rv-index', String(index % 4));
        if (this.enabled('showMedia') && review.image) {
          const media = this.node('button', 'sg-rv__media');
          media.type = 'button';
          media.setAttribute('aria-label', review.video ? this.dataset.videoLabel : this.dataset.openLabel);
          const image = document.createElement('img');
          image.src = review.image;
          if (review.srcset) { image.srcset = review.srcset; image.sizes = '(max-width: 749px) 85vw, (max-width: 1099px) 45vw, 30vw'; }
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          media.append(image);
          if (review.video) {
            const play = this.node('span', 'sg-rv__play');
            play.append(this.svg('M8 5v14l11-7Z'));
            media.append(play);
          }
          media.addEventListener('click', () => this.openReview(review));
          card.append(media);
        } else if (this.enabled('equalHeights') && this.enabled('showMedia') && this.hasMedia) {
          const media = this.node('div', 'sg-rv__media sg-rv__media--placeholder');
          media.setAttribute('aria-hidden', 'true');
          media.append(this.node('span', '', '“'));
          card.append(media);
        }
        const body = this.node('div', 'sg-rv__body');
        if (this.dataset.starsPosition !== 'hidden') body.append(this.stars(review.rating));
        const aligned = this.enabled('equalHeights');
        if (this.enabled('showTitle') && (review.title || aligned)) {
          const title = this.node(review.title ? 'h3' : 'div', 'sg-rv__review-title', review.title);
          if (!review.title) title.setAttribute('aria-hidden', 'true');
          body.append(title);
        }
        body.append(this.node('p', 'sg-rv__quote', review.body));
        const identity = this.node('div', 'sg-rv__identity');
        const reviewerLine = this.node('div', 'sg-rv__reviewer-line');
        if (this.enabled('showName') && (review.name || aligned)) {
          const name = this.node('span', 'sg-rv__name', review.name);
          if (!review.name) name.setAttribute('aria-hidden', 'true');
          reviewerLine.append(name);
        }
        if (reviewerLine.childNodes.length) identity.append(reviewerLine);
        if (this.enabled('showProduct') && (review.product || aligned)) {
          const product = this.node(review.productUrl ? 'a' : 'span', 'sg-rv__product', review.product);
          if (review.productUrl) product.href = review.productUrl;
          if (review.product) product.title = review.product;
          if (!review.product) product.setAttribute('aria-hidden', 'true');
          identity.append(product);
        }
        if (identity.childNodes.length) body.append(identity);
        if (this.enabled('showReadMore')) {
          const button = this.node('button', 'sg-rv__read-more', this.dataset.openLabel);
          button.type = 'button';
          button.addEventListener('click', () => this.openReview(review));
          body.append(button);
        }
        card.append(body);
        return card;
      }

      renderReviews() {
        const source = this.sourceHost.querySelector('.jdgm-cards-carousel');
        if (!source) return;
        this.renderSummary(source);
        const sourceCards = [...source.querySelectorAll('.jdgm-media-card')];
        if (!sourceCards.length) return;
        const records = window.jdgmCarouselMode?.[source.dataset.jdgmBlockId]?.reviews || [];
        const recordsById = new Map();
        records.forEach((record, position) => {
          if (record.uuid != null && !recordsById.has(String(record.uuid))) recordsById.set(String(record.uuid), { record, position });
        });
        const seen = new Set();
        const reviews = sourceCards.map((card, index) => this.readReview(card, index, recordsById)).filter(review => {
          if (!this.enabled('deduplicate')) return true;
          if (seen.has(review.id)) return false;
          seen.add(review.id);
          return true;
        }).sort((a, b) => a.sourcePosition - b.sourcePosition);
        const signature = JSON.stringify(reviews.map(({ sourceCard, sourceRecord, ...review }) => review));
        if (signature === this.signature && sourceCards.length === this.sourceCards?.length && sourceCards.every((card, index) => card === this.sourceCards[index])) return;
        this.signature = signature;
        this.sourceCards = sourceCards;
        this.hasMedia = reviews.some(review => review.image);
        const offset = this.track.scrollLeft;
        this.reveals?.disconnect();
        this.track.replaceChildren(...reviews.map((review, index) => this.buildReview(review, index)));
        this.querySelector('[data-custom]').hidden = false;
        this.sourceHost.hidden = true;
        this.sourceHost.inert = true;
        this.dataset.ready = 'true';
        this.track.scrollLeft = offset;
        if (this.enabled('reveal') && !this.reducedMotion() && 'IntersectionObserver' in window) {
          this.reveals = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) { entry.target.dataset.reveal = 'visible'; this.reveals.unobserve(entry.target); }
            });
          }, { threshold: 0.06 });
          [...this.track.children].forEach(card => { card.dataset.reveal = 'pending'; this.reveals.observe(card); });
        }
        this.updateControls();
      }

      updateControls() {
        if (!this.track || !this.controls) return;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const offset = Math.abs(this.track.scrollLeft);
        this.controls.hidden = this.dataset.layout !== 'carousel' || this.dataset.navigation === 'hidden' || max < 3;
        this.querySelector('[data-previous]').disabled = offset < 3;
        this.querySelector('[data-next]').disabled = offset >= max - 3;
      }

      advance(direction, loop = false) {
        if (this.dataset.layout !== 'carousel') return;
        const first = this.track.firstElementChild;
        if (!first) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = first.getBoundingClientRect().width + gap;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const offset = Math.abs(this.track.scrollLeft);
        const target = loop && direction > 0 && offset >= max - 3 ? 0 : Math.max(0, Math.min(max, offset + step * direction));
        this.track.scrollTo({ left: target * (rtl ? -1 : 1), behavior: this.reducedMotion() ? 'auto' : 'smooth' });
      }
    }
    customElements.define('sg-judge-reviews', SgJudgeReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
